/** Format Google Identity / @react-oauth/google errors for alerts + logs. */
export function formatGoogleAuthError(error) {
  if (!error) return 'Unknown Google sign-in error';
  if (typeof error === 'string') return error;

  const parts = [
    error.type,
    error.error,
    error.error_description,
    error.details,
    error.message,
  ].filter(Boolean);

  if (parts.length > 0) return parts.join(' — ');

  try {
    return JSON.stringify(error);
  } catch {
    return 'Google sign-in failed';
  }
}

/**
 * Hint shown when the failure looks like an OAuth client / origin misconfiguration
 * (the usual localhost breakage).
 */
export function googleOriginHint() {
  return (
    'On localhost, Google only allows origins listed under your OAuth client’s '
    + 'Authorized JavaScript origins. Add both:\n'
    + '  • http://localhost:3000\n'
    + '  • http://127.0.0.1:3000\n'
    + 'Use http://localhost:3000 in the browser (not the 172.x network URL).'
  );
}
